const TYPEFLO_ORIGINS = ['https://dashboard.typeflo.io', 'https://app.typeflo.io', 'http://localhost:3000', 'http://localhost:3001', 'http://localhost:3005'];

export const isTypefloOrigin = () => TYPEFLO_ORIGINS.includes(window.location.origin);
export const isWhitelabelOrigin = () => !isTypefloOrigin();